<template>
	<span>
		<Menu />
		
		<AppLayout title="Create New Task" subtitle="" :showDefaultControls="false">
			<template #content>
				<Loading v-if="loading" :isLoading="loading" />

				<TaskEntryForm 
					v-if="!loading"
					:enableAdvancedControls="true"
					:task="task"
					@saved:task="handleTaskSaved"
				/>
			</template>
		</AppLayout>
	</span>
</template>
<script>
import AppLayout from '@/components/AppLayout.vue'
import CreateTaskPopup from '@/components/CreateTaskPopup.vue'
import Loading from '@/components/Loading.vue'
import Menu from '@/components/menus/UserMenu.vue'
import TaskEntryForm from '@/components/blocks/TaskEntryForm.vue'
import Logger from '@/utils/Logger'

import taskOps from '../mixins/taskOps'
import genericOps from '../mixins/genericOps'

// Create logger with automatic caller detection
// This will show which method is logging (e.g., "preparePage()")
const log = Logger.create('TaskEntry', { showCaller: true })

export default {
	name: 'TaskDetail',
	metaInfo() {
		return {
			title: 'Principal Task | Create Task',
		}
	},
	components: {
		AppLayout,
		Loading,
		Menu,
		TaskEntryForm,
	},
	mixins: [taskOps, genericOps],
	props: {},
	data() {
		return {
			loading: true,
			task: {
				title: 'foo',
				children: [],
			},
		}
	},
	computed: {},
	mounted() {
		this.preparePage()
	},
	async created() {
		
	},
	methods: {
		
		addChildTask(parentTask) {
			//Object.assign(this.task, {})

			if (typeof parent !== 'undefined' && parentTask !== null) {
				this.$set(this.childTask, 'parent', parentTask._id)
				this.$set(this.childTask, 'parentTask', parentTask)
			}

			//////console.log('\n\nTasks.addChildTask passing localTask = ' + JSON.stringify(this.task))

			this.$bvModal.show('taskModal')
		},
		handleTaskSaved(task, saveAction) {

			console.log('saveAction = ' + saveAction)
			
			if(typeof saveAction == 'undefined' || saveAction === null) {

				this.makeToast(true, 'Error', 'Encountered unexpected saveAction = ' + saveAction)

			} else if(saveAction == 'add') {

				this.task = Object.assign({}, this.emptyTask)

			} else if(saveAction == 'new') {

				this.task = Object.assign({}, this.emptyTask)

			} else if(saveAction == 'similar') {

				this.task._id = null
				this.task.id = null
				this.task.notes = null
				this.task.title = null

			}

		},
		async preparePage() {
			log.debug('preparePage: Loading folders and contexts')
			this.loading = true

			try {
				// FIXED (Dec 2024): Load folders and contexts from store before rendering form
				// WHY: TaskEntryForm uses $store.getters.getFolders and $store.getters.getContexts
				// for dropdown options. Without this, dropdowns appear empty on initial page load.
				await log.time('Load folders and contexts', async () => {
					await this.$store.dispatch('getFolders')
					await this.$store.dispatch('getContexts')
				})

				this.task = Object.assign({}, this.emptyTask)
				log.info('Page prepared successfully')
			} catch (error) {
				log.error('Failed to prepare page:', error)
			} finally {
				this.loading = false
			}
		},
		childTaskCreated(newTask, message) {
			// 20200405 -- ZWS -- Refresh the parent when a child is added.

			let that = this

			if (typeof newTask.parent != 'undefined' && newTask.parent !== null && newTask.parent.length > 0) {
				TaskService.getTask(
					this.$store.getters.getUser._id,
					newTask.parent,
					this.$store.getters.getUserToken
				)
					.then(function(response) {
						let resp = response.data.response

						try {
							that.task = resp.data[0]
							////console.log('taskOps.saveComplete has refreshed task = ' + JSON.stringify(that.task))
						} catch (e) {
							////console.log('taskOps.saveComplete encountered an error parsing the data array = ' + e)
						}
					})
					.catch((error) => {
						////console.log('taskOps.saveComplete encountered an error getting a task: ' + JSON.stringify(error))
					})
			}
		},
		localDeleteTask(id) {
			this.deleteTask(id)

			if (typeof this.task == 'undefined' || this.task === null) {
				////console.log('task is null')
				this.$router.go(-1)
			} else {
				////console.log(JSON.stringify(this.task))
			}
		},
	},
}
</script>

<style scoped></style>
